<template>
  <div class="menu">
    <div
      v-for="(menu, i) in menuList"
      :key="i"
      :class="[{'menu__extra-padding': isApp()}, 'menu__item', { 'router-link-exact-active': isMenuActive(menu.path) }]"
      @click="handleMenuClick(menu)"
    >
      <div
        v-if="menu.redDot"
        class="menu__icon"
      >
        <component :is="menu.icon" />
        <span class="menu__icon__dot" />
      </div>
      <div
        v-else
        class="menu__icon"
      >
        <component :is="menu.icon" />
      </div>
      <span :class="`menu__item-${menu.text}`">{{ menu.text }}</span>
    </div>
  </div>
</template>

<script src="./js/menu.js"></script>

<style lang="scss" scoped>
.menu {
  left: 0;
  right: 0;
  bottom: 0;
  gap: 8px;
  z-index: 10;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  position: fixed;
  background-color: #FFF;
  border-top: 1px solid #C8CBCD;

  &__item {
    width: 25%;
    padding: 8px 0;
    display: flex;
    cursor: pointer;
    color: bliket.$blu-color-neutral-icon-default;
    font: bliket.$blu-text-caption-1;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    span {
      font: bliket.$blu-text-caption-1;
      color: bliket.$blu-color-neutral-text-med;
    }

    &.router-link-exact-active {
      color: bliket.$blu-color-info-icon-default;

      span {
        font: bliket.$blu-text-label;
        color: bliket.$blu-color-info-text-default;
      }
    }
  }

  &__icon {
    position: relative;

    &__dot {
      position: absolute;
      top: 1px;
      right: 1px;
      width: 8px;
      height: 8px;
      background-color: #ff4646;
      border-radius: 50%;
      border: 1px solid #ffffff;
    }
  }

  &__extra-padding {
    padding-bottom: 16px;
  }
}
</style>
